import { useQuery } from '@tanstack/react-query';

import { reportingHomeApi } from '@/lib/reporting/home';

export const REPORTING_HOME_QUERY_KEY = ['reporting', 'home'] as const;

export function useReportingHome(days?: number) {
  return useQuery({
    queryKey: [...REPORTING_HOME_QUERY_KEY, days ?? null],
    queryFn: () => reportingHomeApi.home(days),
    refetchInterval: 30_000,
  });
}
